<template>
  <div class="report-error-page" v-if="currentUser">
    <div class="page-header">
      <h1>Zgłoś błąd / sugestię</h1>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <h2>Formularz zgłoszenia</h2>
        <p class="section-subtitle">
          W celu poprawy jakości serwisu jesteśmy otwarci na nowe propozycje.
          Jeśli napotkałeś/aś błąd, opisz go poniżej.
        </p>
      </div>

      <form class="report-form" @submit.prevent="sendReport">
        <div class="form-group">
          <label for="subject">Temat</label>
          <input type="text" id="subject" placeholder="Temat" v-model="subject" name="subject" required>
        </div>

        <div class="form-group">
          <label for="content">Opis</label>
          <textarea name="content" id="content" placeholder="Opisz problem lub sugestię..." v-model="content" required></textarea>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-primary">
            Wyślij
            <img v-if="loading" src="@/assets/icons/loading.gif" alt="ładowanie...">
          </button>
        </div>

        <p v-if="message" class="success-message">{{ message }}</p>
      </form>
    </div>
  </div>

  <div v-else class="section-card loading-state">
    <h4>Ładowanie...</h4>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import axios from 'axios';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';

export default {
  name: 'ReportErrorEmployee',
  setup() {
    useMeta({ title: 'Zgłoś błąd' });

    return {
      authStore: useAuthStore()
    };
  },
  data() {
    return {
      subject: '',
      content: '',
      message: '',
      loading: false
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 4) {
      this.$router.push('/login');
    }
  },
  methods: {
    sendReport() {
      this.loading = true;
      axios.get(`/User/${this.currentUser.id}`).then((res) => {
        const userData = `email: ${res.data.email} | id: ${this.currentUser.id}`;
        axios.post('/SendEmail', {
          email: 'pomoc@m2vet.pl',
          subject: `${this.subject} - ${res.data.email}`,
          title: `${this.currentUser.data.name} | ${userData} pisze:`,
          content: `${this.content}`
        }, authHeader()).then(() => {
          this.message = 'Właśnie otrzymaliśmy twoje zgłoszenie! Odpowiemy na nie jak najszybciej.';
          this.resetForm();
        }).catch(() => {
          this.resetForm();
        });
      }).catch(() => {
        this.resetForm();
      });
    },
    resetForm() {
      setTimeout(() => {
        this.subject = '';
        this.content = '';
        this.message = '';
        this.loading = false;
      }, 3000);
    }
  }
};
</script>

<style scoped lang="scss">
.report-error-page {
  max-width: 1000px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  color: #1f2937;
  font-weight: 700;
}

.section-card {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
}

.section-card-header {
  margin-bottom: 16px;
}

.section-card-header h2 {
  margin: 0;
  font-size: 2rem;
  color: #1f2937;
  font-weight: 700;
}

.section-subtitle {
  margin: 8px 0 0;
  max-width: 760px;
  color: #6b7280;
  font-size: 1.4rem;
  line-height: 1.5;
}

.report-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 1.4rem;
  color: #374151;
  font-weight: 600;
}

.form-group input,
.form-group textarea {
  border-radius: 8px;
  border: 1px solid #d1d5db;
  width: 100%;
  padding: 10px 12px;
  box-sizing: border-box;
  font-size: 1.4rem;
  outline: none;
  transition: border-color 0.2s;
}

.form-group textarea {
  min-height: 220px;
  resize: vertical;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: #10b981;
}

.form-actions {
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.btn-primary {
  background-color: #f2790f;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #fff;
  font-size: 1.4rem;
  font-weight: 600;
}

.btn-primary:hover {
  background-color: #d66a0a;
}

.btn-primary img {
  width: 18px;
  height: 18px;
}

.success-message {
  margin: 0;
  color: #16a34a;
  font-size: 1.5rem;
  font-weight: 600;
}

.loading-state {
  max-width: 800px;
  margin: 24px auto;
  text-align: center;
}

@media (max-width: 480px) {
  .report-error-page {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card-header h2 {
    font-size: 1.8rem;
  }

  .btn-primary {
    width: 100%;
  }
}
</style>